import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const procurementCommentSchema = surrealRecordSchema.extend({
  comment: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ProcurementComment = z.infer<typeof procurementCommentSchema>;
